import { render, staticRenderFns } from "./DashboardReport.vue?vue&type=template&id=71c0fa63&scoped=true"
import script from "./DashboardReport.vue?vue&type=script&lang=js"
export * from "./DashboardReport.vue?vue&type=script&lang=js"
import style0 from "./DashboardReport.vue?vue&type=style&index=0&id=71c0fa63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c0fa63",
  null
  
)

export default component.exports